import React from 'react';
import { LogIn } from 'lucide-react';

// Modal "ya tienes cuenta": el teléfono o correo pertenecen a un dais.user
// activo. Dos ramas según has_consultations (lo decide el backend):
//  - sin consultas: login en agenda para tomar su primera valoración.
//  - con consultas: la fila es solo para asociaciones; renovar o pagar en agenda.
const AGENDA_URL = 'https://agenda.daisies.mx';

export default function AlreadyRegisteredModal({ hasConsultations, onClose }) {
  return (
    <div className="wam-overlay animate-fadeIn">
      <div className="wam-card">
        <div className="wam-header">
          <div className="wam-icon"><LogIn size={24} /></div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <h3 className="wam-title">
              {hasConsultations ? 'Tu cuenta ya tomó consultas' : 'Ya tienes una cuenta en Daisies'}
            </h3>
            <p className="wam-sub">
              {hasConsultations
                ? 'La fila es exclusiva para usuarias de asociaciones y fundaciones seleccionadas. Puedes renovar tu membresía o agendar una consulta de valoración.'
                : 'Inicia sesión para tomar tu primera sesión de valoración.'}
            </p>
          </div>
        </div>

        <div className="wam-body">
          <a
            className="btn-primary press-scale"
            href={AGENDA_URL}
            style={{ justifyContent: 'center', textDecoration: 'none' }}
          >
            {hasConsultations ? 'Ir a agenda' : 'Iniciar sesión'}
          </a>
          <button type="button" className="btn-secondary press-scale" onClick={onClose}>
            Usar otro número o correo
          </button>
        </div>
      </div>
    </div>
  );
}
